import { Routes } from '@angular/router';
import { authGuard } from '@app/core/guards/auth.guard';
import { getMeGuard } from '@app/core/guards/get-me.guard';
import { environment } from '@env/environment';

export const routes: Routes = [
  {
    path: '',
    canActivate: [getMeGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./home/routes'),
      },
      {
        path: 'catalog',
        loadChildren: () => import('./catalog/routes'),
      },
      {
        path: 'reviews',
        loadChildren: () => import('./reviews/routes'),
      },
      {
        path: 'offers',
        loadChildren: () => import('./offers/routes'),
      },
      {
        path: 'financing',
        loadChildren: () => import('./financing/routes'),
      },
      {
        path: 'about-us',
        loadChildren: () => import('./about-us/routes'),
      },
      {
        path: 'euro-charge',
        loadChildren: () => import('./euro-charge/routes'),
      },
      {
        path: 'zeekr-check',
        loadChildren: () => import('./zeekr-check/routes'),
      },
      {
        path: 'warehouse',
        loadChildren: () => import('./warehouse/routes'),
      },
      {
        path: 'contact-us',
        loadChildren: () => import('./contact-us/routes'),
      },
      {
        path: 'comparison',
        loadChildren: () => import('./comparison/routes'),
      },
      {
        path: 'public-offer',
        loadChildren: () => import('./public-offer/routes'),
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () => import('./terms-and-conditions/routes'),
      },
      {
        path: 'search',
        loadChildren: () => import('./search/routes'),
      },
      ...(environment.features.ambassadors ? [
        {
          path: 'test-drive',
          loadChildren: () => import('./test-drive/routes'),
        },
      ] : []),
      {
        path: 'account',
        canActivate: [ authGuard ],
        loadChildren: () => import('./account/routes'),
      },
      {
        path: 'callback',
        loadChildren: () => import('./callback/routes'),
      },
      {
        path: '404',
        loadChildren: () => import('./not-found/routes'),
      },
      {
        path: '**',
        redirectTo: '404',
      },
    ]
  }
];
